module.exports = __webpack_public_path__ + "static/img/ela-responsive-platform.d7b7efc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ela/ela-responsive-platform.png
// module id = ++PM
// module chunks = 1